<template>
    <ul class="nav nav-tabs web-tabs">
        <li class="nav-item">
            <router-link :to="'/statistic/webmasters'" class="nav-link" exact><i class="fa fa-globe"></i> {{ $t('pages.webmasters') }}</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="'/statistic/webmasters/analysis'" class="nav-link" exact><i class="fa fa-tachometer"></i> {{ $t('pages.web_analysis') }}</router-link>
        </li>
    </ul>
</template>

<script>
    export default {
      name: 'WebTabs'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WebTabs.vue?5e06bfa3